<!-- My WorkList -->
<mat-spinner class="mydocs-spinner" *ngIf="isLoadingData && dataSource.data.length <= 0"></mat-spinner>
<div class="mydocs-spinner-text paragraph-medium-regular" *ngIf="isLoadingData && dataSource.data.length <= 0">
  <p>Retrieving data...</p>
</div>
<app-add-reference-card [desc]="emptyMessage" *ngIf="dataSource.data.length < 1 && !isLoadingData">
</app-add-reference-card>
<div class="docs-table-container">
  <div class="table-wrapper" *ngIf="!isLoadingData && dataSource.data.length > 0">
    <table mat-table [dataSource]="dataSource" multiTemplateDataRows class="mat-elevation-z8" matSort>
      <ng-container matColumnDef="{{ column }}" *ngFor="let column of wlColumnsToDisplay">
        <th mat-header-cell *matHeaderCellDef mat-sort-header tabindex="0" (keypress)="sortByColumn(column)" (click)="sortByColumn(column)">
          {{ formatHeader(column) }} <mat-icon>{{sortSettingMap[column] ? 'keyboard_arrow_up' :
            'keyboard_arrow_down'}}</mat-icon>
        </th>
        <div class="date-cell" *ngIf="column === 'PurposeOfPurchase'">
          <td mat-cell *matCellDef="let element" [tp]="element['Purpose']" tpClassName="custom-tooltip" tpMaxWidth="300px" [tpInteractive]="true" tpPlacement="bottom">
            {{ element['Purpose'] }}
          </td>
        </div>
        <div class="date-cell" *ngIf="column === 'ModifiedOn' ">
          <td mat-cell *matCellDef="let element">
            {{ element[column] | date : "dd/MM/yyyy" }}
          </td>
        </div>
        <div class="date-cell" *ngIf="column === 'SubmittedOn'">
          <td mat-cell *matCellDef="let element">
            {{ element[column] | date : "dd/MM/yyyy" }}
          </td>
        </div>
        <div class="date-cell" *ngIf="column === 'DocumentNo'">
          <td mat-cell *matCellDef="let element">
            <a *ngIf="!element.IsRFQSummaryEnable" (click)="navigateToAOWorkList(element)"
              [customContextMenu]="contextMenuTemplate"
              [customContextData]="element"
            >{{ element[column] }}</a>
            <a *ngIf="element.IsRFQSummaryEnable" (click)="navigateToRFQSummary(element)">{{ element[column] }}</a>
          </td>
        </div>
        <div class="date-cell" *ngIf="column === 'RequestingOfficer'">
          <td mat-cell *matCellDef="let element">
            <ng-container *ngIf="!element['IsRFQSummaryEnable']; else rfqSummary">
              {{ element[column] }}
            </ng-container>
            <ng-template #rfqSummary>
              {{ element['RFQSummaryRequestingOfficer'] }}
            </ng-template>
          </td>
        </div>
        <div class="date-cell" *ngIf="column !== 'SubmittedOn' && column !== 'DocumentNo' && column !== 'RequestingOfficer'">
          <td mat-cell *matCellDef="let element">{{ element[column] }}</td>
        </div>
        
      </ng-container>
      <ng-template #contextMenuTemplate let-data>
        <div class="context-menu">
          <ul>
            <li (click)="onContextMenuClick(data, 'open')">
              <mat-icon>arrow_outward</mat-icon>
              Open
            </li>
            <li (click)="onContextMenuClick(data, 'tab')">
              <mat-icon>open_in_new</mat-icon>
              Open in new tab
            </li>
            <!-- disabling copy for async rework -->
            <!-- <li (click)="onContextMenuClick(data, 'copy-link')">
              <mat-icon>content_copy</mat-icon>
              Copy link
            </li> -->
            <li (click)="onContextMenuClick(data, 'copy-documentnumber')">
              <mat-icon>numbers</mat-icon>Copy Document No.
            </li>
          </ul>
        </div>
      </ng-template>
      <!-- <ng-container matColumnDef="expand">
      <th mat-header-cell *matHeaderCellDef aria-label="row actions">&nbsp;</th>
      <td mat-cell *matCellDef="let element">
        <button
          mat-icon-button
          aria-label="expand row"
          (click)="
            expandedElement = expandedElement === element ? null : element;
            $event.stopPropagation()
          "
        >
          <mat-icon *ngIf="expandedElement !== element"
            >keyboard_arrow_down</mat-icon
          >
          <mat-icon *ngIf="expandedElement === element"
            >keyboard_arrow_up</mat-icon
          >
        </button>
      </td>
    </ng-container> -->

      <!-- Expanded Content Column - The detail row is made up of this one column that spans across all columns -->
      <!-- <ng-container matColumnDef="expandedDetail">
      <td
        mat-cell
        *matCellDef="let element"
        [attr.colspan]="columnsToDisplayWithExpand.length"
      >
        <div
          class="element-detail"
          [@detailExpand]="
            element == expandedElement ? 'expanded' : 'collapsed'
          "
        >
          <div class="element-description">
            <div class="element-desc-title">Purpose of purchase:</div>
            <div class="element-desc-text">
              {{ element.Purpose }}
            </div>
          </div>
        </div>
      </td>
    </ng-container> -->

      <tr mat-header-row *matHeaderRowDef="columnsToDisplayWithExpand"></tr>
      <tr mat-row *matRowDef="let element; columns: columnsToDisplayWithExpand" class="element-row"
        [class.expanded-row]="expandedElement === element"
        tabindex="0"
        (keypress)="expandedElement = expandedElement === element ? null : element"
        (click)="expandedElement = expandedElement === element ? null : element"></tr>
      <!-- <tr
      mat-row
      *matRowDef="let row; columns: ['expandedDetail']"
      class="detail-row"
    ></tr> -->
    </table>
  </div>
  <mat-paginator [length]="totalCount" [pageSize]="pageSize" [pageSizeOptions]="pageSizeOptions"
    [pageIndex]="currentPage" (page)="onPageChange($event)" showFirstLastButtons></mat-paginator>
</div>